import React from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { UpArrowOutlined, DownArrowOutlined } from "@toddle-edu/ds-icons";
import { useI18n } from "Hooks";
import classes from "./ReorderButtons.scss";

const ReorderButtons = props => {
  const { isFirstQuestion, isLastQuestion, onMoveUp, onMoveDown } = props;
  const { t } = useI18n(["common"]);

  return (
    <div className={classes.container}>
      <Tooltip tooltip={t("common:move_up")}>
        <IconButton
          icon={<UpArrowOutlined />}
          dsVersion="2.0"
          type="plain"
          variant="neutral"
          size="x-small"
          onClick={onMoveUp}
          disabled={isFirstQuestion}
          testId="worksheet-subquestion-moveUp"
          aria-label={t("common:move_up")}
        />
      </Tooltip>
      <Tooltip tooltip={t("common:move_down")}>
        <IconButton
          icon={<DownArrowOutlined />}
          dsVersion="2.0"
          type="plain"
          variant="neutral"
          size="x-small"
          onClick={onMoveDown}
          disabled={isLastQuestion}
          testId="worksheet-subquestion-moveDown"
          aria-label={t("common:move_down")}
        />
      </Tooltip>
    </div>
  );
};

ReorderButtons.propTypes = {
  onMoveUp: PropTypes.func.isRequired,
  onMoveDown: PropTypes.func.isRequired,
  isFirstQuestion: PropTypes.bool,
  isLastQuestion: PropTypes.bool,
};

ReorderButtons.defaultProps = {
  onMoveUp: () => {},
  onMoveDown: () => {},
  isFirstQuestion: false,
  isLastQuestion: false,
};

export default ReorderButtons;
